module.exports = __webpack_public_path__ + "img/mang1.fdf70ab3.jpg";